import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import { useProjectElementListStore } from '../../../shared/store/projectElementStore';
import SelectBox from '../../../shared/component/SelectBox';
import { NormalTextAreaWithAlignmentMobile, getAlignment } from '../../../shared/component/headless/textarea/TextAreaBody';
import { TextBoxData } from '../../../shared/dto/EntityRepository';
import { SelectType, TextAlignment } from '../../../shared/enum/EnumRepository';
import { PEHeader, PEIndicator, SelectBoxContainer, SelectBoxWrapper } from './WorkMobile';
import MoleculeTextareaDescription from '../../../shared/component/molecule/MoleculeTextareaDescription';
import { TEXTBOX_CONTENT_MAX_LENGTH } from '../../../shared/constants/limits';


export interface TextBoxProps {
  peId: string;
  alignment: TextAlignment;
  data: TextBoxData;
}

const TextBox: React.FC<TextBoxProps> = ({ peId, alignment, data }) => {
  const { isEditMode } = useEditMode();
  const handleChange = useProjectElementListStore((s) => s.updateTextBox);
  const updateTextAlignment = useProjectElementListStore((s) => s.updateTextAlignment);

  const handleAlignmentChange = (value: TextAlignment) => {
    updateTextAlignment(peId, value);
  };

  return (
    <TextBoxWrapper>
      {isEditMode &&
      <PEHeader>
        <SelectBoxContainer>
          <SelectBoxWrapper>
            <SelectBox
              value={alignment || TextAlignment.CENTER}
              selectType={SelectType.TEXT_ALIGNMENT}
              handleChange={handleAlignmentChange}
              direction={false} />
          </SelectBoxWrapper>
        </SelectBoxContainer>
        <PEIndicator peId={peId}>: TextBox</PEIndicator>
        </PEHeader>
      }
      <TextBoxContentWrapper>
        <MoleculeTextareaDescription
          value={data.content}
          alignment={alignment}
          handleChange={(e) => handleChange(peId, { content: e.target.value })}
          StyledTextarea={NormalTextAreaWithAlignmentMobile}
          StyledDescription={TextBoxContent}
          maxLength={TEXTBOX_CONTENT_MAX_LENGTH}
          maxRows={100}
        />
      </TextBoxContentWrapper>
    </TextBoxWrapper>
  );
}

export const TextBoxWrapper = styled.div`
  position: relative;
  min-height: 80px;
`;

const TextBoxContentWrapper = styled.div`
  padding: 0 clamp(18px, 5vw, 24px);
`;

const TextBoxContent = styled.div<{ $alignment: TextAlignment }>`
  padding: 8px 0;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  text-align: ${({ $alignment }) => getAlignment($alignment)};
  ${({ theme }) => theme.typography.Body_04};
  line-height: 1.4;
`;

export default TextBox;